import { selectActiveIndex, selectModuleState } from "Redux/appSlice";
import { useAppSelector } from "Redux/hooks";
import NavigatorChevron from "../Atoms/NavigatorChevron";

function Placeholder() {
  return <div className="h-8 w-8"></div>;
}

/**
   @function ModuleNavigator
   navigate module 
   @param onClickUp {function} - called when button up is clicked 
   @param onClickDown {function} - called when button down is clicked 
*/
export default function ModuleNavigator({
  onClick,
}: {
  onClick: (index?: number) => void;
}) {
  const moduleState = useAppSelector(selectModuleState);
  const activeIndex = useAppSelector(selectActiveIndex);
  if (!moduleState) {
    return null;
  }
  const selectedSteps = moduleState.initialization.selectedSteps;
  const iteratedSteps = selectedSteps
    .map((step, i) => {
      if (i === 0) {
        return i;
      }
      if (selectedSteps[i - 1].iterated) {
        return i;
      }
    })
    .filter((e) => e !== undefined);

  return (
    <div className="absolute bottom-14 right-12 z-50 flex h-20 flex-col justify-between">
      {activeIndex !== 0 ? (
        <NavigatorChevron
          id="ButtonUp"
          onClick={() => onClick(0)}
          direction="up"
          newClassName="  z-20"
          label="Go to first question"
        />
      ) : (
        <Placeholder />
      )}
      {activeIndex !== iteratedSteps.length - 1 ? (
        <NavigatorChevron
          id="ButtonDown"
          onClick={() => onClick(iteratedSteps[iteratedSteps.length - 1])}
          direction="down"
          newClassName="  z-20"
          label="Go to last question"
        />
      ) : (
        <Placeholder />
      )}
    </div>
  );
}

/*

*/
